const AUTH_EVENTS = {
  USER_LOGGED_IN: 'AUTH_EVENTS.USER_LOGGED_IN',
  USER_LOGGED_OUT: 'AUTH_EVENTS.USER_LOGGED_OUT',
  COMPANY_CHANGED: 'AUTH_EVENTS.COMPANY_CHANGED',
};

export default AUTH_EVENTS;
